import { useOrganization } from '@/contexts/OrganizationContext';

/**
 * Simple hook to get the current organization ID.
 * This is a convenience wrapper around useOrganization for use in data hooks.
 */
export const useOrganizationId = () => {
  const { organizationId } = useOrganization();
  return organizationId;
};
